import { Component } from '@angular/core';

@Component({
  selector: '[app-tr-provider]',
  template: ``,
  styleUrls: []
})
export class TrProviderComponent {

}
